import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/EnvironmentalBenefitsEmissionControlHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-34.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ebec { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .ebec-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .ebec-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .ebec-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .ebec-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .ebec-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .ebec-hero-divider {
    width: 520px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .ebec-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .ebec-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .ebec-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .ebec-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .ebec-bc-item:hover { color: #EB2019; }
  .ebec-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .ebec-bc-sep img { width: 24px; height: 24px; display: block; }
  .ebec-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .ebec-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .ebec-main-section { padding: 80px 0 120px 0; }
  .ebec-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .ebec-article { flex: 1; min-width: 0; }

  .ebec-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .ebec-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .ebec-meta-item:last-child { border-right: none; padding-right: 0; }
  .ebec-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .ebec-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .ebec-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .ebec-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ebec-article-body p { margin-bottom: 20px; }
  .ebec-article-body p:last-child { margin-bottom: 0; }

  .ebec-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  /* Numbered ol list */
  .ebec-article-body ol {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 20px;
    counter-reset: ebec-counter;
  }
  .ebec-article-body ol li {
    display: flex; align-items: flex-start; gap: 0px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; counter-increment: ebec-counter;
  }
  .ebec-article-body ol li::before {
    content: counter(ebec-counter) '.';
    font-weight: 600; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .ebec-article-body ol li > span { flex: 1; }

  .ebec-article-body strong { font-weight: 600; color: #202020; }

  .ebec-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .ebec-red-link:hover { opacity: 0.8; }

  .ebec-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 400; }
  .ebec-red-link-plain:hover { opacity: 0.8; }

  /* Hashtags */
  .ebec-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .ebec-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .ebec-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .ebec-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .ebec-nav-btn:hover { color: #EB2019; }
  .ebec-nav-btn img { width: 40px; height: 40px; display: block; }

  .ebec-share-icons { display: flex; align-items: center; gap: 20px; }
  .ebec-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .ebec-share-icon:hover { opacity: 0.85; }
  .ebec-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .ebec-sidebar { flex: 0 0 475px; }
  .ebec-sidebar-block { margin-bottom: 60px; }
  .ebec-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .ebec-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .ebec-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .ebec-recent-item:hover .ebec-recent-title { color: #EB2019; }
  .ebec-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .ebec-recent-body { flex: 1; min-width: 0; }
  .ebec-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .ebec-social-icons { display: flex; align-items: center; gap: 30px; }
  .ebec-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .ebec-social-icon:hover { opacity: 0.8; }
  .ebec-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .ebec-hero             { height: 350px; }
    .ebec-hero-content     { padding: 0 32px; }
    .ebec-hero-title       { font-size: 30px; }
    .ebec-hero-divider     { width: 100%; max-width: 479px; }
    .ebec-breadcrumb       { padding: 24px 0 0 0; }
    .ebec-breadcrumb-inner { padding: 0 32px; }
    .ebec-inner            { padding: 0 32px; }
    .ebec-main-section     { padding: 48px 0 60px 0; }
    .ebec-main-row         { flex-direction: column; gap: 48px; }
    .ebec-sidebar          { flex: none; width: 100%; }
    .ebec-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .ebec-hero             { height: 360px; }
    .ebec-hero-content     { padding: 0 16px; }
    .ebec-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .ebec-hero-divider     { width: 100%; }
    .ebec-hero-subtitle    { font-size: 14px; }
    .ebec-breadcrumb       { padding: 30px 0 0 0; }
    .ebec-breadcrumb-inner { padding: 0 16px; }
    .ebec-bc-item          { font-size: 14px; gap: 14px; }
    .ebec-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .ebec-bc-sep img       { width: 22px; height: 22px; }
    .ebec-inner            { padding: 0 16px; }
    .ebec-main-section     { padding: 30px 0 60px 0; }
    .ebec-main-row         { flex-direction: column; gap: 60px; }
    .ebec-sidebar          { flex: none; width: 100%; }
    .ebec-article-title    { font-size: 20px; margin-bottom: 15px; }
    .ebec-article-body     { font-size: 14px; }
    .ebec-article-body p   { margin-bottom: 15px; }
    .ebec-article-body ol  { margin: 0 0 20px 0; gap: 15px; }
    .ebec-article-body ol li { font-size: 14px; }
    .ebec-article-body strong { font-size: 16px; }
    .ebec-meta-item        { font-size: 14px; }
    .ebec-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .ebec-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .ebec-hashtags         { margin-top: 30px; font-size: 14px; }
    .ebec-nav-btn img      { width: 24px; height: 24px; }
    .ebec-nav-btn          { font-size: 14px; }
    .ebec-share-icon img   { width: 34px; height: 34px; }
    .ebec-sidebar-title    { font-size: 20px; }
  }
`;

const recentPosts = [
    {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function EnvironmentalBenefitsEmissionControl() {
  return (
    <div className="ebec">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="ebec-hero">
        <img className="ebec-hero-bg" src={HeroBgImg} alt="The Environmental Benefits of Upgrading Your Emission Control System Hero" />
        <div className="ebec-hero-overlay" />
        <div className="ebec-hero-content">
          <h1 className="ebec-hero-title">
            The Environmental Benefits of Upgrading Your Emission Control System
          </h1>
          <hr className="ebec-hero-divider" />
          <p className="ebec-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="ebec-breadcrumb" aria-label="Breadcrumb">
        <div className="ebec-breadcrumb-inner">
          <a href="/" className="ebec-bc-item">Home</a>
          <span className="ebec-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="ebec-bc-item">News &amp; Updates</a>
          <span className="ebec-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="ebec-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="ebec-main-section">
        <div className="ebec-inner">
          <div className="ebec-main-row">

            {/* ── ARTICLE ── */}
            <article className="ebec-article">

              {/* Meta bar */}
              <div className="ebec-meta-bar">
                <span className="ebec-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="ebec-meta-item"><img src={CalendarIcon} alt="date" /> November 15, 2024</span>
                <span className="ebec-meta-item"><img src={ClockIconImg} alt="time" /> 11:29 am</span>
                <span className="ebec-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="ebec-article-title">
                The Environmental Benefits of Upgrading Your Emission Control System
              </h1>

              {/* Body */}
              <div className="ebec-article-body">

                <p>As industrial operations grow, minimizing emissions has become a priority for environmental and regulatory reasons. Upgrading your emission control system helps your facility comply with today's standards and brings powerful ecological benefits. At Ador, we see firsthand how advanced <strong>emission control systems</strong> can reduce pollution, save energy, and protect ecosystems.</p>

                {/* Article image */}
                <img className="ebec-article-img" src={ArticleImg} alt="Environmental Benefits of Upgrading Emission Control System" />

                <p>Here's why upgrading your system is brilliant for the planet and your operations.</p>

                <ol>
                  <li><span><strong>Cleaner Air, Less Pollution</strong><br />
                  An upgraded emission control system does a far better job of capturing pollutants than older models. Advanced systems, like Ador's high-performance Electrostatic Precipitators (ESPs), are designed to capture even the tiniest dust particles, fly ash, and other emissions before they reach the air. This feature means cleaner air and a prominent decrease in pollution, particularly in locations around industrial establishments.</span></li>

                  <li><span><strong>Energy Savings That Benefit Everyone</strong><br />
                  Up-to-date <strong>emission control systems</strong> are built to operate more efficiently, meaning they use less power while maintaining high performance. At Ador, our ESPs are equipped with advanced transformer-rectifier units and control cubicles that optimize power use based on your facility's needs. This doesn't just cut down on energy costs—it also lowers the carbon emissions from your facility, making it a win-win for both your business and the environment.</span></li>

                  <li><span><strong>Contributing to a Low-Carbon Future</strong><br />
                  As industries worldwide work towards decreasing carbon emissions, every little bit counts. By upgrading your emission control system, you're taking an energetic role in decarbonization—lowering greenhouse gas emissions contributing to climate change. Ador's systems are built with high efficiency and low energy use in mind, aligning with multinational goals to decrease industrial emissions and save the earth.</span></li>

                  <li><span><strong>Defending Local Ecosystems</strong><br />
                  Industrial emissions influence more than just the air; they can affect soil, water, and covering ecosystems. When pollutants settle on land or nearby water sources, they can harm plant life, contaminate drinking water, and disrupt natural habitats. Upgraded <a href="#" className="ebec-red-link-plain">emission control systems</a> are more functional at entrapping these pollutants, allowing local ecosystems to be healthier and sustaining a safe environment for nearby neighborhoods.</span></li>

                  <li><span><strong>More restorative Communities, More substantial Connections</strong><br />
                  Cleaner emissions indicate healthier air, which helps the environment and the people in surrounding areas. Lessening airborne pollutants can reduce respiratory problems and other health threats associated with industrial pollution. Establishments investing in upgraded emission control systems are committed to public health, fostering community trust and goodwill.</span></li>

                  <li><span><strong>Less Waste, More Sustainable Practices</strong><br />
                  With a modern emission control system, your facility can capture pollutants more effectively, reducing the waste that requires handling. Efficiently trapped pollutants can often be recycled or processed responsibly, reducing contaminants released into the environment. Upgraded systems also reduce the need for frequent maintenance, helping to make waste management more sustainable and cost-effective.</span></li>
                </ol>

                <span className="ebec-h2">Why Choose Ador for Your Emission Control Needs?</span>

                <p>Our commitment to sustainable, high-performance solutions ensures we provide advanced emission control systems that address key aspects of the combustion process and exhaust emissions. Whether it's managing unburned hydrocarbons, nitrogen oxides, or carbon monoxide from the engine exhaust, our systems are designed to optimize engine efficiency and minimize environmental impact.</p>

                <p>Ador's technologies, including air injection systems, positive crankcase ventilation (PCV) valves, exhaust gas recirculation (EGR) systems, and enhancements to the exhaust system, fuel tank, and carburetor, work seamlessly to reduce harmful emissions. By regulating the air-fuel mixture in the combustion chamber and enabling efficient gas recirculation, our solutions improve the overall combustion process while ensuring compliance with environmental standards.</p>

                <p>When you choose Ador's emission control systems, you're not just upgrading equipment but investing in a cleaner, healthier tomorrow. Ready to see the difference an upgraded emission control system can make?</p>

                <p>Contact us today to learn how Ador can help your facility achieve efficient, environmentally friendly emissions control.</p>

                <p className="ebec-hashtags"><strong>#EmissionControl #CleanAir #SustainableIndustry #AdorGroup #IndustrialSolutions #EcoFriendlyOperations</strong></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="ebec-bottom-row">
                <div className="ebec-bottom-nav">
                  <a href="/news/understanding-esp-components" className="ebec-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/5-signs-you-need-to-replace-your-esp-mechanical-spares/" className="ebec-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="ebec-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/5-signs-you-need-to-replace-your-esp-mechanical-spares/" className="ebec-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2F5-signs-you-need-to-replace-your-esp-mechanical-spares%2F&mode=login" className="ebec-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2F5-signs-you-need-to-replace-your-esp-mechanical-spares%2F%26title%3D5%2520Signs%2520to%2520Replace%2520Your%2520ESP%2520Mechanical%2520Spares%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2F5-signs-you-need-to-replace-your-esp-mechanical-spares%2F" className="ebec-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="ebec-sidebar">

              {/* Recent Posts */}
              <div className="ebec-sidebar-block">
                <p className="ebec-sidebar-title">Recent Posts</p>
                <div className="ebec-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="ebec-recent-item">
                      <img src={post.img} alt={post.title} className="ebec-recent-img" />
                      <div className="ebec-recent-body">
                        <span className="ebec-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="ebec-sidebar-block" target="blank">
                <p className="ebec-sidebar-title">Social Media</p>
                <div className="ebec-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="ebec-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="ebec-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}